<template>
  <!-- 选择优惠券 -->
  <div class="component">
    <div class="button" @click="onCouponShow">
      <slot :count="coupon.list.length" :activeName="coupon.activeName"></slot>
    </div>
    <van-popup v-model="coupon.show" closeable position="bottom" round>
      <div class="popup">
        <div class="title">
          {{ coupon.type == "exchange" ? "兑换优惠券" : "选择优惠券" }}
        </div>
        <div class="content">
          <div class="list" v-show="coupon.type != 'exchange'">
            <div class="item" :class="{ disabled: onCouponDisabled(item) }" v-for="(item, index) in coupon.list"
              :key="index" @click="onCouponChange(item)">
              <div class="checked">
                <van-radio :name="item.id" icon-size="16px" v-model="coupon.active"
                  :disabled="onCouponDisabled(item)" />
              </div>
              <div class="item-box">
                <div class="head">
                  <div class="name">
                    {{
      item.userMemberName
        ? coupon.names[item.couponType]
        : item.couponName
    }}
                  </div>
                  <div class="desc">{{ onCouponRuleName(item) }}</div>
                </div>
                <div class="foot">
                  <div class="cell" v-if="item.userMemberName">
                    使用人：{{ item.userMemberName }}
                  </div>
                  <div class="cell">
                    使用期限：{{
      timeFormat(item.validBeginDate, "yyyy-mm-dd")
    }}~{{ timeFormat(item.validEndDate, "yyyy-mm-dd") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="none" v-if="!coupon.loading && !coupon.list.length">
              暂无可用优惠券
            </div>
            <div class="space"></div>
          </div>
          <div class="exchange" v-show="coupon.type == 'exchange'">
            <div class="exchange-box">
              <van-field v-model="coupon.code" placeholder="请输入优惠券兑换码" />
            </div>
          </div>
        </div>
        <div class="footer">
          <template v-if="coupon.type === 'exchange' && exchangeable">
            <van-button class="cancel" type="defualt" size="small" plain @click="coupon.type = 'list'">取消</van-button>
            <van-button type="info" size="small" @click="onCouponExchangeSubmit">确认兑换</van-button>
          </template>
          <template v-else>
            <van-button type="info" size="small" plain @click="onCouponExchangeShow"
              v-if="exchangeable">兑换优惠券</van-button>
            <van-button type="info" size="small" @click="onCouponConfirm">确认</van-button>
          </template>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import request from "@/utils/request";
import { timeFormat } from "@/utils/baseFormat";
import qs from "qs";

export default {
  name: "coupon-select",
  components: {},
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    userMemberId: {
      // 就诊人id
      type: [String, Number],
      default: "",
    },
    totalFee: {
      // 药品总金额
      type: [String, Number],
      default: "0.00",
    },
    userNo: {
      type: String,
      default: "",
    },
    exchangeable: {
      type: Boolean,
      default: true,
    },
    useType: {
      type: Number,
      default: 0,
    },
    couponId: {
      type: [Number, String],
      default: null,
    },
    couponName: {
      type: String,
      default: null,
    },
    autoPick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      coupon: {
        show: false,
        active: "",
        activeName: "",
        type: "list", // list：显示列表、exchange：显示兑换
        list: [],
        loading: false,
        code: "",
        names: [
          "购药满减券",
          "购药折扣券",
          "购药免费券",
          "协议问诊抵扣券",
          "挂号金额全额抵扣券",
          "购药满收券"
        ],
      },
    };
  },
  computed: {},
  mounted() { },
  destroyed() { },
  methods: {
    timeFormat,
    onCouponGet() {
      // 获取优惠券列表
      return new Promise(async (resolve, reject) => {
        this.coupon.loading = true;
        const toast = this.$toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
        try {
          const { data, code } = await request({
            method: "post",
            url: "/order-service/app/coupon/availableCoupon",
            data: {
              userNo: this.userNo,
              useType: this.useType,
            },
            headers: { "Content-Type": "application/json" },
          });
          this.coupon.loading = false;
          toast.clear();
          if (code == 0) {
            this.coupon.list = data || [];
            if (this.autoPick) {
              this.onCouponAutoPick(data || []);
            }
            resolve(true);
          } else {
            reject(false);
          }
        } catch (error) {
          this.coupon.loading = false;
          toast.clear();
          reject(false);
        }
      });
    },
    onCouponShow() {
      this.coupon.active = this.couponId || "";
      this.coupon.type = "list";
      this.coupon.show = true;
    },
    onCouponExchangeShow() {
      this.coupon.code = "";
      this.coupon.type = "exchange";
    },
    async onCouponExchangeSubmit() {
      if (!this.coupon.code) {
        this.$toast("请输入优惠券兑换码");
        return false;
      }
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      try {
        await this.onCouponExchangeSend();
        toast.clear();
        this.coupon.type = "list";
        this.onCouponGet();
      } catch (error) {
        toast.clear();
      }
    },
    onCouponExchangeSend() {
      return new Promise(async (resolve, reject) => {
        try {
          const { code } = await request({
            method: "post",
            url: `/order-service/app/coupon/receive/${this.userNo}`,
            data: qs.stringify({
              couponCode: this.onCouponTransform(this.coupon.code),
              userNo: this.userNo,
              receiveType: 2,
            }),
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          });
          if (code == 0) {
            resolve(true);
          } else {
            reject(false);
          }
        } catch (error) {
          reject(false);
        }
      });
    },
    onCouponTransform(str) {
      let reg = new RegExp("[?&]code=([^&]*)(&|$)");
      let res = str.match(reg);
      return (res && res[1]) || str;
    },
    onCouponRuleName(row) {
      // 优惠规则名称
      return {
        0: `单次问诊满${row.full || 0}元抵扣${row.free || 0}元`,
        1: `单次问诊${row.discount || 0}折优惠`,
        2: `单次问诊金额全额抵扣`,
        3: `协议抵扣券`,
        4: `单次挂号金额全额抵扣`,
        5: `订单金额满${row.full || 0}元收${row.free || 0}元`
      }[row.couponType];
    },
    onCouponDisabled(row) {
      return (
        (row.couponType === 0 && row.full > this.totalFee) ||
        (row.userMemberId && row.userMemberId != this.userMemberId) ||
        (row.couponType === 5 && this.totalFee < row.full) ||
        parseFloat(this.totalFee) <= 0
      );
    },
    onCouponChange(row) {
      if (!this.onCouponDisabled(row)) {
        if (this.coupon.active === row.id) {
          this.coupon.active = null;
          this.coupon.activeName = "";
        } else {
          this.coupon.active = row.id;
          this.coupon.activeName = row.userMemberName
            ? this.coupon.names[row.couponType]
            : row.couponName;
        }
      }
    },
    onCouponConfirm() {
      // if (!this.coupon.active) {
      //   this.$toast("请选择优惠券");
      //   return false;
      // }
      const find = this.coupon.list.find((row) => row.id == this.coupon.active);
      this.onCouponInput(find);
      this.coupon.show = false;
    },
    onCouponInput(row) {
      if (row) {
        const amount = this.onCouponAmount(row);
        this.$emit("input", amount);
        this.$emit("update:couponId", row.id);
        this.$emit("change", {
          row,
          amount,
        });
        this.$emit('update:couponName', row.userMemberName
          ? this.coupon.names[row.couponType]
          : row.couponName)
      } else {
        this.$emit("input", 0);
        this.$emit("update:couponId", null);
        this.$emit("change", {
          row: {},
          amount: 0,
        });
        this.$emit('update:couponName', '')
      }
    },
    onCouponAmount(row) {
      if ([2, 3, 4].includes(row.couponType)) {
        // 单次免费券 || 协议问诊免费
        return this.totalFee;
      } else if (row.couponType == 1) {
        // 折扣券
        return (this.totalFee * (1 - row.discount / 10)).toFixed(2);
      } else if (row.couponType == 0) {
        // 满减
        return row.free > this.totalFee ? this.totalFee : row.free;
      } else if (row.couponType === 5) {
        // 满收
        return this.totalFee > row.full ? parseFloat((this.totalFee - row.free).toFixed(2)) : 0
      }
    },
    onCouponAutoPick(list) {
      let max = 0;
      let valid = false;
      let index = -1;
      for (let i = 0; i < list.length; i++) {
        const invalid = this.onCouponDisabled(list[i]);
        if (!invalid) {
          if (!valid) valid = true;
          if (index === -1) index = i;
          const price = parseFloat(this.onCouponAmount(list[i]));
          if (price > max) {
            max = price;
            index = i;
          }
        }
      }
      if (index >= 0) {
        this.onCouponInput(list[index]);
      }
    },
  },
  watch: {
    userNo: {
      handler(value) {
        value && this.onCouponGet();
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.popup {
  .title {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    font-size: 20px;
    font-weight: bold;
  }

  .content {
    height: 50vh;

    .list {
      height: 50vh;
      overflow-y: auto;

      .item {
        display: flex;
        align-items: center;
        padding: 20px 20px 0;

        .checked {
          flex: none;
          margin-right: 20px;
        }

        &-box {
          flex: 1;
          background: #f4f4f4;
          padding: 20px;
          border-radius: 10px;

          .name {
            font-weight: bold;
            font-size: 20px;
          }

          .desc {
            margin-top: 5px;
            color: #999;
          }

          .foot {
            margin-top: 10px;
            color: #999;

            .cell {
              &:not(:first-child) {
                margin-left: 15px;
              }
            }
          }
        }

        &.disabled {
          .item-box {
            .name {
              color: #999;
            }
          }
        }
      }
    }

    .exchange {
      height: 30vh;
      display: flex;
      align-items: center;
      justify-content: center;

      &-box {
        border: 1px solid #ccc;
        width: 80%;
        border-radius: 4px;
      }
    }

    .none {
      height: 70%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #999;
    }

    .space {
      height: 20px;
    }
  }

  .footer {
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .van-button {
      flex: 1;
      margin: 0 10px;
      border-radius: 4px;

      &:first-child {
        width: 30%;
        flex: none;
      }

      &.cancel {
        background: #f2f2f2;
        color: #666;
        border: none;
      }
    }
  }
}
</style>
